module.exports = __webpack_public_path__ + "static/CRS_05_new-6811e11bd64e1233dca0c3c661e139fd.svg";